import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { AppConstants } from '../../../../config/appConstants';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'option-content',
    templateUrl: 'option-content.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class OptionContentComponent {
    @Input() usedOption: any;
    @Input() isUSLabel: boolean;
    prepaidCardsAndEchecks = AppConstants.PREPAIDCARDSAndECHECKS;
}
